import axios, { baseURL } from '@axios'
import { paginateArray, sortCompare } from '@/common'
import { getUserData } from '@/auth/utils'
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
   
    addReply(ctx, userData) {
      let payload = {
        reviewId: userData.reviewId,
        toReplyId: userData.toReplyId,
        comment: userData.comment,
        isAnonymous: true,
      };
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/Review/AddReply`, payload )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteUser(ctx, { id, status }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`${baseURL}/api/Contact/Delete`, {
            params: {
              contactId: id,
              status
            }})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchReviewShop(ctx, queryParams) {
      const userData = getUserData()

      const payload = {
        "pagination": {
          "total": 0,
          "current": 0,
          "pageSize": 0
        },
        "search": {
          "entityId": null,
          "entityTypeId": 3,
          "shopId": userData.shopId,
          "isMedia": false,
          "ratingLevel": null
        },
        "sort": {
          "predicate": 'created_date',
          "reverse": true
        }  
      }

      axios.defaults.headers.common["Authorization"] = "Bearer " + userData.token

      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/Review/Grid`, payload)
          .then(response => {
            const {
            q = '',
            perPage = 10,
            page = 1,
            sortBy = 'created_date',
            sortDesc = false,
            status,
            plan
          } = queryParams

          // const queryLowered = q.toLowerCase()
          var dataFromAPI = response.data.data.list
     
          
          // const filteredData = dataFromAPI.filter(
          //   user =>
              /* eslint-disable operator-linebreak, implicit-arrow-linebreak */
              // user
          // )

          // const sortedData = filteredData.sort(sortCompare(sortBy))
          // if (sortDesc) sortedData.reverse()

          resolve({
            data: paginateArray(dataFromAPI, perPage, page),
            totalCount: response.data.data.pagination.length,
          })})
          .catch(error => reject(error))
      })
    },
  },
}
